// extracted by mini-css-extract-plugin
export default {"AwarenessContainer":"HXdVk","leafIconContainer":"oWwJq","leafIcon":"fjwsr","textContainer":"Ryz5f","message":"G10Sm","catchphrase":"RJYs6"};